import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-act-statutes',
  templateUrl: './act-statutes.component.html',
  styleUrls: ['./act-statutes.component.scss']
})
export class ActStatutesComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
